import {  useEffect, useState } from "react";
import { Text, TableContainer, Tr, Td, Th, Table, Thead, Tbody, Icon, Heading, Box, useToast, Tooltip, Button, Modal, ModalOverlay, ModalContent, ModalHeader, CloseButton, ModalBody, ModalFooter, useDisclosure, FormControl, FormLabel, Input, RadioGroup, Radio, Stack, Checkbox, Textarea} from "@chakra-ui/react";

import { DeleteIcon, EditIcon ,CopyIcon} from "@chakra-ui/icons";
import createAxiosInstance from "../../../../interceptors/useAxiosInterceptors";
import { useSession } from "../../../../SessionContext";
import {  useNavigate} from "react-router-dom";
import logout from "../../../../services/authService";

import { BiMailSend } from "react-icons/bi";
import { RiAddLargeFill } from "react-icons/ri";
import { initSurveyService } from "../../../../services/http/surveyHttpService";
import { getExpertsGroupsADP } from "../../../../services/http/surveyHttpService";
import { useTranslation } from "react-i18next";
import { useExchangeData } from "../ExchangeDataProvider";
import { deleteExpertsGroupADP } from "../../../../services/http/surveyHttpService";
import { cloneExpertGroupADP } from "../../../../services/http/surveyHttpService";
export default function GroupsConsensusView (){
  const {t} = useTranslation();

  const [value, setValue] = useState("");
  const { isOpen: isGroupCreateModalOpen, onOpen: onGroupCreateModalOpen, onClose: onGroupCreateModalClose } = useDisclosure();

  const [groups, setGroups] = useState([]);
  const toast = useToast();
  const [message, setMessage] = useState("");
  const { updateSessionData, clearSessionData} = useSession();
  const { updateDataGroup,setUpdateDataGroup } = useExchangeData();

  const navigate = useNavigate();

 const { isOpen: isOpenModalConfirmDeleteGroup, onOpen: onOpenModalConfirmDeleteGroup, onClose: onCloseModalConfirmDeleteGroup } = useDisclosure();
 const { isOpen: isOpenModalCloneGroup, onOpen: onOpenModalCloneGroup, onClose: onCloseModalCloneGroup } = useDisclosure();


  const [payloadUploadDashboard, setPayloadUploadDashboard] = useState({});

  const [payloadCloneGroup, setPayloadCloneGroup] = useState({});


  const axiosInstance = createAxiosInstance(async (axiosInstance)=> {

    logout(t, clearSessionData,navigate,toast,axiosInstance)
  });

  initSurveyService(t, toast, axiosInstance)
  /*
  Carica le dashboards in una tabella ogni volta che viene caricata la pagina (useEffect) interrogando l'endpoint con 
  l'invio di un json contente il token di identificaione, l'username dellutente e una costante caseType per indicare al backend 
  di quale chiamata si tratta e quali paremetri deve inviarci. Per consultare i case type consultare il file CaseTypeConstant.js  
  */
  useEffect(() => {
    getExpertsGroupsADP(sessionStorage.getItem("username")).then(res => {
        console.log(res)
    if(res != null && res.expertsGroups != null && res.expertsGroups.length >0)
    setGroups(res.expertsGroups)
  })

  onGroupCreateModalOpen(true)
},[]);
  


const [searchCheckedCategories, setSearchCheckedCategories] = useState(
  [])



  const handleCategoryChange = (category) => {
    setSearchCheckedCategories((prevCategories) => {
      // Controlla se la categoria è già selezionata
      const isCategoryChecked = prevCategories.includes(category);
  
      // Se è già selezionata, la rimuoviamo; altrimenti, la aggiungiamo
      const updatedCategories = isCategoryChecked
        ? prevCategories.filter((c) => c !== category)  // Rimuovi la categoria
        : [...prevCategories, category];  // Aggiungi la categoria
  
      // Aggiorna il payload con le categorie modificate
      setPayloadUploadDashboard((prev) => ({
        ...prev,
        categories: updatedCategories,  // Usa le categorie aggiornate
      }));
  
      return updatedCategories;  // Ritorna l'array aggiornato
    });
  };




      const submitDashboard = async () => {
        if(payloadUploadDashboard.dashboardName != null && payloadUploadDashboard.dashboardName.length >0 &&
          payloadUploadDashboard.linkDashboard != null && payloadUploadDashboard.linkDashboard.length >0 &&
          
          payloadUploadDashboard.visibility != null && payloadUploadDashboard.categories.length > 0 &&
          payloadUploadDashboard.description != null && payloadUploadDashboard.description.length >0
        ) {
        try{
         
           }

      
      catch(error) {
        toast({
          title: t('toastMsg.error'),
          description: String(error),
          position: "top",
          status: 'warning',
          duration: 4000,
          isClosable: true});
    }



  }
      


      }
      
      const [openDashboardModal, setOpenDashboardModal] = useState(false);
      const [linkDashboard, setLinkDashboard] = useState("")

      const onCloseDashboardViewModal = () => {
        setOpenDashboardModal(false)
      }

      /*const openDashboardViewModal = (link) => {
      setLinkDashboard(link)
      setOpenDashboardModal(true)
      }*/

      const openDashboardViewModal = (link) => {
        //const encodedLink = encodeURIComponent(link);
        navigate('/iframe', { state: { link } });
        }


      
    return(
        <>

     {/*
     <CreateGroupModal
        isOpen={isGroupCreateModalOpen}
    
        onClose={onGroupCreateModalClose}
        ></CreateGroupModal>
     */}   



 
<Modal onClose={onCloseModalConfirmDeleteGroup} isOpen={isOpenModalConfirmDeleteGroup} isCentered closeOnOverlayClick={false} >
            <ModalOverlay />
            <ModalContent>
              <ModalHeader>   {t('survey.tableGroup.doYouConfirmToRemoveTheGroup')} </ModalHeader>
              <ModalBody></ModalBody>
              <ModalFooter>
                <Button colorScheme='green' mr={3} onClick={()=> {
                  
                  deleteExpertsGroupADP(t, updateDataGroup.expert_group_id).then((res)=> {
                  onCloseModalConfirmDeleteGroup()
                  toast({
                    title: "",
                    description: res.message,
                    position: "bottom",
                    status: res.status =="404" ? "error": "info",
                    duration: 2000,
                    isClosable: true});
                    setGroups((prevGroups) => prevGroups.filter((group) => group.expert_group_id !== updateDataGroup.expert_group_id));
                  }
)
                }}>
                   {t('survey.tableGroup.yes')}
                </Button>
                <Button colorScheme='red' onClick={onCloseModalConfirmDeleteGroup}>
                  No
                </Button>
              </ModalFooter>
            </ModalContent>
          </Modal>


          <Modal isOpen={isOpenModalCloneGroup} onClose={onCloseModalCloneGroup} isCentered closeOnOverlayClick={false}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>{t('survey.cloneGroups')}</ModalHeader>
        <ModalBody>
          <FormControl id="new-title" isRequired>
            <FormLabel>{t('survey.cloneGroup.newTitle')}</FormLabel>
            <Input
                 value={payloadCloneGroup.newTitle} 
              onChange={(e) => {
                setPayloadCloneGroup((prev) => ({
                  ...prev,
                  newTitle: e.target.value,
                }));
              
              }}
              placeholder={t('survey.cloneGroup.newTitlePlaceholder')}
            />
          </FormControl>
          <FormControl id="new-description" mt={4}>
            <FormLabel>{t('survey.cloneGroup.description')}</FormLabel>
            <Input
              value={payloadCloneGroup.description} 
              onChange={(e) => {
                setPayloadCloneGroup((prev) => ({
                  ...prev,
                  description: e.target.value,
                }));

               
              }}


              placeholder={t('survey.cloneGroup.descriptionPlaceholder')}
            />
          </FormControl>
        </ModalBody>
        <ModalFooter>
          <Button colorScheme="green" mr={3} onClick={()=> {
           
        
            payloadCloneGroup.owner =sessionStorage.getItem("username")

            cloneExpertGroupADP(t,payloadCloneGroup).then(res => {
              

              if(res) {

              toast({
                title: res.message,
                status: "success",
                isClosable: true
               
              });

              getExpertsGroupsADP(sessionStorage.getItem("username")).then(res => {
                if(res != null && res.expertsGroups != null && res.expertsGroups.length >0)
              setGroups(res.expertsGroups)
              })

              onCloseModalCloneGroup()
              setPayloadCloneGroup({})
            }
              
            })

          }}>
            {t('survey.cloneGroup.btnCloneGroup')}
          </Button>
          <Button colorScheme="red" onClick={()=> {onCloseModalCloneGroup(); setPayloadCloneGroup({}) }}>
            {t('survey.cloneGroup.cancel')}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
          



         {/*<Modal onClose={onLogoutModalClose} isOpen={isLogoutModalOpen} isCentered>
            <ModalOverlay />
            <ModalContent>
              <ModalHeader> Do you confirm you want to leave the session?</ModalHeader>
              <ModalBody></ModalBody>
              <ModalFooter>
                <Button colorScheme='green' mr={3} onClick={logOut}>
                  Si
                </Button>
                <Button colorScheme='red' onClick={onLogoutModalClose}>
                  No
                </Button>
              </ModalFooter>
            </ModalContent>
          </Modal>*/}


        <Box alignItems={"center"} justifyContent={"space-between"} display={"flex"} color={"rgba(11,78,90,255)"} bgColor={"#f6f3ec"}><Heading>{t('survey.expertGroups')}</Heading> <Button  color={"rgba(11,78,90,255)"} bgColor={"#f6f3ec"} h={"100%"} onClick={()=> {onGroupCreateModalOpen(); navigate("/group-create?hideHeader=true&hideNavbar=true")}}><Icon as={RiAddLargeFill}/>{t('survey.createGroups')}</Button></Box>
        <Box bgColor={"white"}   overflowY="auto" direction="column" h="100%" w="100%" boxShadow="lg">
        <TableContainer px={"1%"} paddingTop={"1%"} >
        
        <Table variant='striped' >
    
        <Thead bgColor="#0888BE">
      <Tr>
        <Th whiteSpace="normal" wordBreak="break-word" minW="150px" w="15%" color="white">
          {t('survey.tableGroup.title')}
        </Th>
        <Th whiteSpace="normal" wordBreak="break-word" minW="200px" w="40%" color="white">
          {t('survey.tableGroup.description')}
        </Th>
      
        <Th whiteSpace="normal" wordBreak="break-word" minW="120px" w="10%" color="white">
          {t('survey.tableGroup.creationDate')}
        </Th>
       
     
        <Th color="white">{t('survey.tableGroup.actions')}</Th>
      </Tr>
    </Thead>
     
      <Tbody  maxHeight="100%" overflowY="auto" borderWidth={1} boxShadow="lg">
      {groups.length > 0 ? 
      
    (groups.map(item=> (


    <Tr>
      <Td  whiteSpace={"normal"} wordBreak={"break-word"}> {item.title}</Td>
      <Td  whiteSpace={"normal"} wordBreak={"break-word"}>{item.description}</Td>
      <Td  whiteSpace={"normal"} wordBreak={"break-word"}>{item.creation_date}</Td>
      <Td  whiteSpace={"normal"} wordBreak={"break-word"}>


      <Tooltip  label="Clone Group" aria-label="Clone Group">
  <Icon ml={"10%"}
    as={CopyIcon} // Sostituisci con l'icona corretta per aggiornare
    onClick={() =>{  


      setPayloadCloneGroup((prev) => ({
        ...prev,
        expert_group_id: item.expert_group_id,
      }));

      setPayloadCloneGroup((prev) => ({
        ...prev,
        description: item.description,
      }));

      
      onOpenModalCloneGroup()
    
    }}
    _hover={{ color: "blue.200" }}
    cursor="pointer"
  />
</Tooltip>

      {!item.is_associated_at_survey  && (

<>
<Tooltip label="Update Group" aria-label="Update Group">
  <Icon ml={"10%"}
    as={EditIcon} // Sostituisci con l'icona corretta per aggiornare
    onClick={() =>{ setUpdateDataGroup(item) ; navigate("/group-update?hideHeader=true&hideNavbar=true")}}
    _hover={{ color: "blue.200" }}
    cursor="pointer"
  />
</Tooltip>
<Tooltip  label="Delete Group" aria-label="Delete Group">
  <Icon ml={"10%"}
    as={DeleteIcon} // Sostituisci con l'icona corretta per aggiornare
    onClick={() =>{ setUpdateDataGroup(item); onOpenModalConfirmDeleteGroup()}}
    _hover={{ color: "blue.200" }}
    cursor="pointer"
  />
</Tooltip>

</>
)}

  



{item.status === 1 && item.owner === sessionStorage.getItem("username") && (
  <Tooltip label="Open Survey To Public" aria-label="Open Survey To Public">
    <Icon
      as={BiMailSend} // Sostituisci con l'icona corretta per aggiornare
      onClick={() =>{}}
      _hover={{ color: "blue.200" }}
      cursor="pointer"
    />
  </Tooltip>
)}

 

      </Td>
    </Tr>))): (<Tr><Text fontSize={"lg"} fontWeight={"bold"}>{message}</Text></Tr>)}

      </Tbody>
      
     
    </Table> 
  </TableContainer>
  </Box> 



                            </>



    )


}






